<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Viga&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');

* {
    border: 0px black solid;
    background-color: #fff5f5;

}

.title_story {
  font-size: 80px;
  font-family: 'Work Sans', sans-serif;
  padding-left: 20px;
  padding-top: 70px;
  color: #333042
}


a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-right: 50px;
  padding-top: 40px;
  font-family: 'Poppins', sans-serif;;
  font-size: 15px;
  padding-left: 20px;
}

.egg_images img {
  max-width: 90%;
  padding-top: 40px;
  padding-bottom: 40px;
}

.container_width {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 70px;

}

.author {
  font-size: 20px;
  font-family: 'Poppins', sans-serif;;
  padding-left: 20px;


}

.small_icon {
  max-width: 20%;
  padding-top: 70px;
}


   @media (max-width: 575px){
     .small_icon {
       max-width: 50%;
       padding-top: 20px;

     }
     .title_story {
       font-size: 30px;
     }
     .author {
       font-size: 15px;
     }
   }

</style>

<template>
  <b-container fluid class="p-0">
    <MenuBar/>
    <b-row>
      <b-col md="8">
        <p class="title_story">Breakfasts</p>
        <b-row>
          <b-col md="6">
            <p class="author">a reflection by Laura Vlasa</p>

          </b-col>
        </b-row>
      </b-col>

      <b-col md="2" class="small_icon">
        <div class="zoom">
        <a href="/cart"><b-img center class="img-fluid" alt="Responsive image" src="media/cart_prev.png"> </b-img></a>
      </div>
      </b-col>
      <b-col md="2" class="small_icon">
        <div class="zoom">
        <a href="/noodles"><b-img center class="img-fluid" alt="Responsive image" src="media/noodles_next.png"> </b-img></a>
      </div>
      </b-col>

    </b-row>


    <b-row>
      <b-col md="5">
<div class='content'>
<p>I have started eating in the morning, actually eating, not just chugging sugarless coffee on an empty stomach and calling it intermittent fasting.
</p>
<p>
I have also started to cook more without any recipe, just by following my proverbial and literal gut, and the results are surprisingly good.
</p>
<p>
I know I am a good cook for most of the time but I also feel the need for validation, so eating alone, though not unprecedented, is something I have yet to get accustomed to.
</p>
<p>
I've attached some photos in hopes that I would somewhat get the validation I was mentioning earlier.</p>
</div>
      </b-col>
      <b-col md="7">
        <b-container fluid class="egg_images">
          <b-row>
            <b-col md="6">
              <b-img class="img-fluid" src="media/breakfast/breakfast2.jpg"> </b-img>
            </b-col>
            <b-col md="6">
              <b-img class="img-fluid" src="media/breakfast/breakfast1.jpg"> </b-img>
            </b-col>
          </b-row>

        </b-container>
      </b-col>
</b-row>
      </b-container>
</template>

<script>
import MenuBar from '../MenuBar'
export default {
    name: 'breakfast',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
